import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DatePicker from './DatePicker.json';
import Header from './Header.json';
import MeasurementTable from './MeasurementTable.json';
import Modals from './Modals.json';
import Modes from './Modes.json';
import PatientInfo from './PatientInfo.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyList from './StudyList.json';
import ToolTip from './ToolTip.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';

export default { 
  'test-LNG': {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DatePicker,
    Header,
    MeasurementTable,
    Modals,
    Modes,
    PatientInfo,
    SidePanel,
    StudyBrowser,
    StudyList,
    ToolTip,
    UserPreferencesModal,
    ViewportDownloadForm,
  }
};
